(function(){
    /**** Helper Functions ****/
  
    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    var keys = {37: 1, 38: 1, 39: 1, 40: 1};
  
    function preventDefault(e) {
      e.preventDefault();
    }
  
    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }
  
    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
      }));
    } catch(e) {}
  
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
  
    // call this to Disable Scroll
    function disableScroll() {
      window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
      window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }
  
    // call this to Enable Scroll
    function enableScroll() {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener('touchmove', preventDefault, wheelOpt);
      window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }
  
    /**** Start of disable scroll functionality ****/
  
     function isValidEmail(value) {
       if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
         return true;
       }
       return false;
     }
  
     function isPrivacyPolicyChecked() {
       return !!document.querySelector('#notify-me-checkbox:checked');
     }
  
    /**** End of Helper Functions ****/
  
    /**** Start of Event Handling ****/
    if (document.querySelector('.notify_me_stock_btn') == null) {
      // Please do not remove this line below as it is required so as not to break
      // the mini-cart from updating upon clicking add to cart button in PDP.
      document.querySelector('.iStock-wrapper') && document.querySelector('.iStock-wrapper').remove();
      
    } else {
  
      var notifyMeAlertElement = document.querySelector('.iStock-msg');
      var notifyMeButtons = document.querySelectorAll('.notify_me_stock_btn');
      var notifyMePanel = document.querySelector('.iStock-wrapper');
      var siteHeader = document.querySelector('#shopify-section-header');
      var notifyMePanelOverlay = document.querySelector('.iStock-overlay');
      var productForm = document.querySelector('.product-form');
      var checkCustomMessage;
      const stockHeading = document.querySelector('.iStock-wrapper > h2');
      const notifyFields = document.querySelector('.notify-me-name-fields')
      const istockFields = document.querySelector('.iStock-fields')
  
      notifyMeButtons.forEach((notifyMeButton) => {
        notifyMeButton.addEventListener('click', event => {
            var notifyMeCustomisedMsg = document.querySelector('.notify-me-customized-msg');
      
            stockHeading && stockHeading.classList.remove('d-none');
            notifyFields && notifyFields.classList.remove('d-none');
            istockFields && istockFields.classList.remove('d-none');
            istockFields && istockFields.classList.remove('d-none');
      
            siteHeader.classList.add('hide-site-header');
            notifyMeAlertElement.innerText = "";
            notifyMePanel.classList.remove('vertically-align-item');
            notifyMePanel.classList.add('iStock-slide-in');
            notifyMeCustomisedMsg.classList.add('d-none');
            notifyMePanelOverlay.classList.remove('d-none');
      
            document.querySelector('.iStock-notify-btn').disabled = true;
            document.querySelector('.iStock-notify-btn').classList.add('disabled-btn');
      
            disableScroll();
      
            const iStockRegisterBtn = document.querySelector('.iStock-notify-btn');
      
            iStockRegisterBtn.addEventListener('click', (event) => {
              stockHeading && stockHeading.classList.add('d-none');
              notifyFields && notifyFields.classList.add('d-none');
              istockFields && istockFields.classList.add('d-none');
              istockFields && istockFields.classList.add('d-none');
      
              notifyMeCustomisedMsg.classList.remove('d-none');
              notifyMePanel.classList.add('vertically-align-item');
            });
      
            document.querySelector('#notify-me-checkbox').addEventListener('change', function() {
              const emailAddress = document.getElementById('notify-me-email').value;
      
              if (this.checked && isValidEmail(emailAddress)) {
                document.querySelector('.iStock-notify-btn').disabled = false;
                document.querySelector('.iStock-notify-btn').classList.remove('disabled-btn');
              }
      
              if (!this.checked) {
                document.querySelector('.iStock-notify-btn').disabled = true;
                document.querySelector('.iStock-notify-btn').classList.add('disabled-btn');
              }
            });
      
            document.querySelector('#notify-me-email').addEventListener('focusout', function() {
              if (!isValidEmail(this.value) && this.value != "") {
                document.querySelector('.notify-me-error-message').classList.remove('d-none');
              }
              if (isValidEmail(this.value)) {
                document.querySelector('.notify-me-error-message').classList.add('d-none');
              }
              if (this.value == "") {
                document.querySelector('.notify-me-error-message').classList.add('d-none');
              }
      
              //if (isValidEmail(this.value) && isPrivacyPolicyChecked()) {
              if (isValidEmail(this.value)) {
                document.querySelector('.iStock-notify-btn').disabled = false;
                document.querySelector('.iStock-notify-btn').classList.remove('disabled-btn');
              } else {
                document.querySelector('.iStock-notify-btn').disabled = true;
                document.querySelector('.iStock-notify-btn').classList.add('disabled-btn');
              }
      
            });
      
          });
      })
  
      var closeNotifyMePanelBtn = document.querySelector('.iStock-wrapper .icon-close');
  
      closeNotifyMePanelBtn.addEventListener('click', event => {
        notifyMePanel.classList.remove('iStock-slide-in');
        siteHeader.classList.remove('hide-site-header');
        notifyMePanelOverlay.classList.add('d-none');
  
        enableScroll();
        clearInterval(checkCustomMessage);
      });
  
      notifyMePanelOverlay.addEventListener('click', event => {
        notifyMePanel.classList.remove('iStock-slide-in');
        siteHeader.classList.remove('hide-site-header');
        notifyMePanelOverlay.classList.add('d-none');
  
        enableScroll();
        clearInterval(checkCustomMessage);
      });
    }
    /**** End of Event Handling ****/
  })();
  